// extracted by mini-css-extract-plugin
module.exports = {"alert-msg":"snackbar_alert-msg__SoiIY","alert-title":"snackbar_alert-title__NJrNg"};